var _desc;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasonTeeOpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 686,
    height: 750,
    viewBox: "34 26 686 750",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "mason_tee.DXF - scale = 25.400000, origin = (0.000000, 0.000000), method = manual")), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 4,
      strokeDasharray: "none",
      stroke: "#000000",
      strokeOpacity: 1
    },
    transform: "matrix(0.3238,0,0,0.3238,-30.685089,89.741429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1788.81 2116.72v-96m-863.996 0v96m48-1536h-288m-288 0h-192m0 768h192m288 0h288m0 0v672m0-2208v768m767.996 1440v-2208m48 2304H924.814m863.996-96H924.814m431.996-1056-383.996 384m0-768 383.996 384m-1151.996 384v-768m768-768h767.996m576 2304h-216m-72-360 72 72m0-288-72 72m0-144 72 72m-72-216v144m0-864 72 72m-72-216v144m72-216-72 72m0-144 72 72m-72-216v144m72-216-72 72m0-144 72 72m-72-216v144m72-216h216m0 2304v-2304m-216 864-72 72m0 0v144m0 720v144m72-792-72 72m72 792-72 72m0 0v144m72-792-72 72m72-1512-72 72m0 1152v144m0 0 72 72m-72-360 72 72m-72 1080 72 72m-1415.996-2232v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m-216 0v-2304m216 0 72 72m-288 2232h216m-216-2304h216",
    style: {
      fill: "#999999",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.556 401.993V278.89h58.421v246.203h-58.42Z",
    style: {
      fill: "#b3b3b3",
      fillOpacity: 1,
      stroke: "#b3b3b3",
      strokeWidth: 4.00000004,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(3.0883261,0,0,3.0883261,94.765562,-277.1508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.955 521.237c0-2.974-2.552-6.396-11.13-14.923l-11.13-11.064 11.13-11.188 11.13-11.187v-48.692l-11.13-11.064-11.13-11.065 11.13-11.187 11.13-11.188v-48.691l-11.13-11.065-11.13-11.064 11.13-11.188c8.46-8.504 11.13-12.098 11.13-14.984v-3.796h91.12l61.546 61.557 61.545 61.556-61.557 61.545-61.556 61.545h-91.098z",
    style: {
      fill: "#b3b3b3",
      fillOpacity: 1,
      stroke: "#b3b3b3",
      strokeWidth: 5.56391,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(3.0883261,0,0,3.0883261,94.765562,-277.1508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.15 635.324V528.56l62.595-62.582c34.426-34.42 62.594-63.214 62.594-63.985s-28.168-29.565-62.594-63.985l-62.594-62.583V29.906h246.203v712.181H285.15zm-15.3 124.15V744.87h276.805v29.211H269.85Z",
    style: {
      fill: "#b3b3b3",
      fillOpacity: 1,
      stroke: "#b3b3b3",
      strokeWidth: 5.56391,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(3.0883261,0,0,3.0883261,94.765562,-277.1508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m638.776 762.575-11.445-11.505v-44.398l12.142-12.198 12.142-12.199-12.142-12.199-12.142-12.198v-44.401l12.142-12.199 12.142-12.199-12.142-12.198-12.142-12.199v-44.401l12.142-12.199 12.142-12.198-12.142-12.199-12.142-12.198v-44.402l12.142-12.198 12.142-12.199-12.142-12.198-12.142-12.199v-44.518l11.824-11.761c6.502-6.47 11.823-12.472 11.823-13.34s-5.32-6.686-11.823-12.929l-11.824-11.35v-43.815l11.824-11.762c6.502-6.47 11.823-12.416 11.823-13.214 0-.8-5.32-6.746-11.823-13.215l-11.824-11.762v-43.814l11.824-11.351c6.502-6.243 11.823-12.06 11.823-12.929 0-.867-5.32-6.87-11.823-13.34L627.33 97.43V52.796l11.505-11.445 11.505-11.445h67.404V774.08H650.22zM98.76 401.993V29.906h67.523l11.445 11.505 11.445 11.504v45.91l-11.128 11.062c-6.12 6.085-11.128 11.718-11.128 12.52 0 .8 5.008 6.434 11.128 12.518l11.128 11.062v46.033l-11.128 11.063c-6.12 6.084-11.128 11.718-11.128 12.519 0 .8 5.008 6.434 11.128 12.518l11.128 11.063v44.24l-11.823 12.082c-6.503 6.645-11.824 12.681-11.824 13.413s5.32 6.624 11.824 13.094l11.823 11.761v43.244l-11.823 11.761c-6.503 6.47-11.824 12.416-11.824 13.215s5.32 6.745 11.824 13.214l11.823 11.762v43.243l-11.823 11.762c-6.503 6.47-11.824 12.361-11.824 13.093s5.32 6.768 11.824 13.414l11.823 12.082v44.24l-11.128 11.062c-6.12 6.085-11.128 11.718-11.128 12.519 0 .8 5.008 6.434 11.128 12.519l11.128 11.062v46.033l-11.128 11.063c-6.12 6.084-11.128 11.718-11.128 12.518s5.008 6.435 11.128 12.52l11.128 11.062v46.029l-11.505 11.445-11.504 11.445H98.759Z",
    style: {
      fill: "#a02c2c",
      fillOpacity: 1,
      stroke: "#a02c2c",
      strokeWidth: 5.56391,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(3.0883261,0,0,3.0883261,94.765562,-277.1508)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasonTeeOpt);
export default __webpack_public_path__ + "static/media/mason_tee_opt.ac5f4c7ba82c14bc9ec8014308043c70.svg";
export { ForwardRef as ReactComponent };